<template>
    <v-card style="border-radius:4px;">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">Copy Compensation & Benefits</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" >
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" style="color:red;">{{ errorMessage }}</p>
        <v-card-text>
            <v-data-table
                :headers="header"
                :items="allocation_history"
                :hide-actions="allocation_history.length<5"
            >
                <template v-slot:items="props">
                    <tr @click="props.expanded = !props.expanded" style="cursor:pointer;" title="Click to view options">
                        <td>{{props.item.fiscalYear}}</td>
                        <td>
                            <b :class="commonfn.getStatusColor(props.item.allocationStatus)">{{commonfn.getStatusDescription(props.item.allocationStatus)}}</b>
                        </td>
                        <td>
                            <v-btn  dark color="primary" :loading="loading" @click="copy(props.item)" title="Copy allocation from this calendar year">
                                <v-icon small>content_copy</v-icon>&nbsp;&nbsp;Copy&nbsp;
                            </v-btn>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>

import allocationApi from '@/api/allocation'
import commonfn from '@/common/functions'

export default {
    data () {
        return {
            commonfn,
            email: null,
            loading: false,
            error: false,
            errorMessage: null,
            expand: false,
            header: [
                {text: 'Calendar Year',align: 'left',value: '',width: '40%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '40%', sortable:false},
                {text: '',align: 'left',value: '',width: '10%', sortable:false},
            ],
            userId: null,
            fiscalPeriodId: null,
            allocation_history: [],
            fiscalPeriodIdToCopy: null,
        }
    },
    methods: {
        viewDetails(data) {
            this.$emit('send',data)
        },
        async setData(data){
            this.allocation_history = []
            this.fiscalPeriodIdToCopy = null
            this.userId = data.userId
            this.fiscalPeriodId = data.fiscalPeriodId

            await this.getAllocHistory()
        },
        async copy(selectedData) {
             try {
                this.loading = true
                var data = {
                    fiscalPeriodId: this.fiscalPeriodId,
                    fiscalPeriodIdToCopy: selectedData.fiscalPeriodId,
                    userId: this.userId
                }
                const response = await allocationApi.copy(data)
                if (response && response.status==200){
                    this.$emit('send',null)
                    this.closeDialog()
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getAllocHistory() {
            try {
                this.loading = true
                const response = await allocationApi.getHistory(this.fiscalPeriodId,this.userId)
                if (response&&response.status==200){
                    this.allocation_history = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAllocHistory', false)
        },
    },
    created() {},
    computed: {
        disabled() {
            return !this.fiscalPeriodIdToCopy
        }
    }
}
</script>